import React from 'react'
import { Skeleton } from '@chakra-ui/react'
import { Menu, MenuList } from '@chakra-ui/react'

import {
    UserBasicInfoFragment,
    ActionItemFieldsFragment,
    useUpdateActionItemMutation,
    useGetClinicAdminsByClinicQuery,
} from '~graphql/generated/graphql'
import AssigneeItem from './assignee-item'
import AssigneeButton from './assignee-button'
import { AvatarProps } from '@chakra-ui/react'

interface Props {
    actionItem: ActionItemFieldsFragment
    size?: AvatarProps['size']
}

export default function AssigneeSelect({ actionItem, size }: Props) {
    const { assignee, clinic } = actionItem

    const { data, loading } = useGetClinicAdminsByClinicQuery({
        variables: {
            clinicId: clinic?.id || '',
        },
    })

    const [updateActionItem, { loading: updating }] =
        useUpdateActionItemMutation()

    function handleSelectAssignee(user?: UserBasicInfoFragment) {
        if (user) {
            updateActionItem({
                variables: {
                    id: actionItem.id,
                    data: {
                        assignee: user.id,
                    },
                },
            })
        } else {
            updateActionItem({
                variables: {
                    id: actionItem.id,
                    data: {
                        assignee: null,
                    },
                },
            })
        }
    }

    return (
        <Skeleton isLoaded={!loading && !updating} rounded="full">
            <Menu isLazy>
                <AssigneeButton assignee={assignee} size={size} />
                <MenuList>
                    <AssigneeItem onSelect={handleSelectAssignee} />
                    {data?.getClinicAdminsByClinic.map(admin => {
                        const user = admin.user as UserBasicInfoFragment

                        return (
                            <AssigneeItem
                                key={user.id}
                                user={user}
                                onSelect={handleSelectAssignee}
                            />
                        )
                    })}
                </MenuList>
            </Menu>
        </Skeleton>
    )
}
